import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import type { ContentStatus } from '../constants/ContentStatus';
import { getQuerySingleContentStatusArrayVariable } from '../utils/getQuerySingleContentStatusArrayVariable';
import { ContentDataClassificationQuery } from '../queries/ContentDataClassificationQuery.graphql';

export function preloadContentDataClassification(contentId: string, contentStatus: ContentStatus) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ContentDataClassificationQuery,
		variables: {
			contentId,
			lowerCaseContentStatusArray: getQuerySingleContentStatusArrayVariable([contentStatus]),
		},
	});
}
